import { get } from '../Services/http';
import { catchError } from './Error.action';
import { pushEcommerce } from './../Services/Gtm.service';

import {
  FACETED_SEARCH_QUERY,
  FACETED_SEARCH_RECEIVE,
  FACETED_SEARCH_ERROR,
  FACETED_SEARCH_TOGGLE_VALUE,
  FACETED_SEARCH_TOGGLE_COMPACT,
  WHEELBUILDER_RECEIVE_RIMS_AND_CAR_MODEL,
  WHEELBUILDER_RECEIVE_TIRES,
} from '../constants';

import {
  setProductsInProductsView,
  setProductsLoading,
} from './ProductsView.action';

export const query = (queryString = '', withProductsResult = true) => (
  dispatch
) => {
  let url = withProductsResult
    ? '/api/productFilter/withProductsResult'
    : '/api/productFilter';
  if (queryString && queryString.trim() !== '') {
    url += `?${queryString}`;
  }
  dispatch(setProductsLoading(true));
  return get(url)
    .then((response) => response.json())
    .then((result) => {
      const { products, sortCriteria, subNavigation, ...others } = result;
      if (withProductsResult) {
        dispatch(setProductsInProductsView(products));
      }
      result = {
        ...others,
        sortCriteria,
        subNavigation,
      };
      dispatch(receive(result));
      if (result.gtmViewModel !== null) {
        pushEcommerce(result.gtmViewModel);
      }
    })
    .catch((ex) => dispatch(catchError(ex, (error) => searchError(error))))
    .finally(() => dispatch(setProductsLoading(false)));
};

const toGroupedFilterCriteria = (flattened, groups) => {
  let groupedFilters = [];
  const reduced = flattened.reduce((result, filter) => {
    const prefix = filter.split('=')[0];
    const value = filter.split('=')[1];
    result[prefix] = result[prefix] || [];
    result[prefix].push(value);
    return result;
  }, {});
  Object.keys(reduced).filter((x) => {
    var sorted = reduced[x].sort((a, b) => a - b);
    let groupIsSlider = groups.find((y) => y.id == x).asSlider;
    if (groupIsSlider) {
      if (sorted.length == 1) {
        groupedFilters.push(`${x}=${sorted[0] + '-' + sorted[0]}`);
      } else {
        groupedFilters.push(`${x}=${sorted.join('-')}`);
      }
    } else {
      reduced[x].forEach((y) => groupedFilters.push(`${x}=${y}`));
    }
  });
  return groupedFilters;
};

export const getFacetFiltersAsQuery = (facetFilters) => {
  const filterCriteria = toFilterCriteria(facetFilters);
  const groupedFilterCriteria = toGroupedFilterCriteria(
    filterCriteria,
    facetFilters
  );
  const filterIds = facetFilters.map((filter) => filter.id);
  const ignoredParams = ['page'];
  const unChangedParams = (window.location.search.substr(1) || '')
    .split('&')
    .filter((param) => {
      const [id, value] = param.split('=');
      return (
        param.length > 0 &&
        !filterIds.includes(id) &&
        !ignoredParams.includes(id)
      );
    });
  return [...unChangedParams, ...groupedFilterCriteria].join('&');
};

const submit = (facetFilters) => (dispatch) => {
  const q = getFacetFiltersAsQuery(facetFilters);
  dispatch(saveQuery(q));
  return dispatch(query(q));
};

const submitWheelBuilderFacetChange = (
  facetFilters,
  carmodel,
  rimArticleNumber,
  step
) => (dispatch) => {
  const q = getFacetFiltersAsQuery(facetFilters);
  var url = '/api/wheelbuilder/facet';

  if (carmodel) {
    url += `?carmodel=${carmodel}`;
  }
  if (rimArticleNumber) {
    url += `&rimArticleNumber=${rimArticleNumber}`;
  }
  if (step) {
    url += `&step=${step}`;
  }
  if (q) {
    url += `&${q}`;
  }

  get(url)
    .then((res) => res.json())
    .then((data) => {
      let filters, products;
      if (step == 2) {
        filters = data.rims.filters;
        products = data.rims.products;

        dispatch({
          type: WHEELBUILDER_RECEIVE_RIMS_AND_CAR_MODEL,
          payload: {
            rims: products,
            pagination: data.rims.pagination,
          },
        });
      }
      if (step == 3) {
        filters = data.filters;
        products = data.products;

        dispatch({
          type: WHEELBUILDER_RECEIVE_TIRES,
          payload: {
            tires: data.products,
            pagination: data.pagination,
            hasWheelDimensions: data.hasWheelDimensions,
            isShowingDefaultWheelDimensions:
              data.isShowingDefaultWheelDimensions,
          },
        });
      }
      if (filters) {
        dispatch(facetClientChanged(filters));
      }
      if (products) {
        dispatch(setProductsInProductsView(products, true));
      }
    })
    .catch((ex) => console.log(ex));
};

const toFilterCriteria = (groups) =>
  groups
    .map((group) =>
      group.selectedOptions
        .filter((val) =>
          group.asSlider
            ? group.selectedOptions.length == 2
            : val && val.length > 0
        )
        .map(
          (val) => `${encodeURIComponent(group.id)}=${encodeURIComponent(val)}`
        )
    )
    .reduce((flat, current) => [...flat, ...current], []);

/**
 *
 * @param filter : the group has changed facet
 * @param option : changed facet
 */
export const searchFacetChange = (filter = null, option = null) => (
  dispatch,
  getState
) => {
  if (filter) {
    const allFilters = getState().facetedSearch.facetFilters;
    const wheelBuilder = getState().wheelBuilder;
    let newFilters = [];
    if (filter.asSlider) {
      newFilters = updateSliderFilterOptions(allFilters, filter, option);
    } else {
      newFilters = updateFilterOption(allFilters, filter, option);
    }
    if (wheelBuilder && wheelBuilder.selectedCarModelVariantSystemId) {
      const step = wheelBuilder.currentStep;
      const rimArticleNumber = wheelBuilder.selectedRim
        ? wheelBuilder.selectedRim.id
        : null;
      return dispatch(
        submitWheelBuilderFacetChange(
          newFilters,
          wheelBuilder.selectedCarModelVariantSystemId,
          rimArticleNumber,
          step
        )
      );
    }
    return dispatch(submit(newFilters));
  }
};

export const updateFilterOption = (
  allFilters = [],
  filter = null,
  option = null
) => {
  if (!filter) return allFilters;
  const filterIndex = allFilters.findIndex((f) => f.id === filter.id);
  const newFilter = option
    ? toggleFilterValue(filter, option)
    : { ...filter, selectedOptions: [] };
  const newFilters = [
    ...allFilters.slice(0, filterIndex),
    newFilter,
    ...allFilters.slice(filterIndex + 1),
  ];
  return newFilters;
};

export const updateSliderFilterOptions = (
  allFilters = [],
  filter = null,
  option = []
) => {
  if (!filter) return allFilters;
  const filterIndex = allFilters.findIndex((f) => f.id === filter.id);

  let filterCopy = filter;
  filterCopy.selectedOptions = option;
  const newFilters = [
    ...allFilters.slice(0, filterIndex),
    filterCopy,
    ...allFilters.slice(filterIndex + 1),
  ];
  return newFilters;
};

const toggleFilterValue = (filter, option) => {
  const { singleSelect, selectedOptions } = filter;
  const optionIndex = selectedOptions.indexOf(option.id);
  const newSelectedOptions =
    optionIndex < 0
      ? // not yet selected, select it
        singleSelect
        ? [option.id]
        : [...selectedOptions, option.id]
      : // selected, deSelect  it
        [
          ...selectedOptions.slice(0, optionIndex),
          ...selectedOptions.slice(optionIndex + 1),
        ];
  return { ...filter, selectedOptions: newSelectedOptions };
};

export const setFilterSelectedOptions = (id, selectedOptions) => (
  dispatch,
  getState
) => {
  const filters = getState().facetedSearch.facetFilters;
  const filterIndex = filters.findIndex((f) => f.id == id);
  if (filterIndex < 0) return;
  const filter = filters[filterIndex];
  filter.selectedOptions = selectedOptions;
  filters[filterIndex] = filter;
  dispatch(facetClientChanged(filters));
};

export const submitSearchFacet = (allFilters) => (dispatch, getState) => {
  dispatch(facetClientChanged(allFilters));
  return dispatch(submit(allFilters));
};

export const facetClientChanged = (facetFilters) => ({
  type: FACETED_SEARCH_TOGGLE_VALUE,
  payload: {
    facetFilters,
  },
});

export const toggleVisibleDropdownMenu = ({ id }) => ({
  type: FACETED_SEARCH_TOGGLE_COMPACT,
  payload: {
    visibleDropdownMenu: id,
  },
});

export const searchError = (error) => ({
  type: FACETED_SEARCH_ERROR,
  payload: {
    error,
  },
});

export const receive = (payload) => {
  return {
    type: FACETED_SEARCH_RECEIVE,
    payload,
  };
};

export const saveQuery = (queryString) => ({
  type: FACETED_SEARCH_QUERY,
  payload: {
    query: queryString,
  },
});

export const updateSubNavigationLinks = (facetedSearchState) => {
  const subNavElem = document.querySelector('#layout-left-column nav');
  if (!subNavElem) return;

  const links = subNavElem.getElementsByTagName('a');
  const currentQuery = new URLSearchParams(location.search);
  const facetFilters = facetedSearchState.facetFilters;
  const data = {
    Width: facetFilters.find((f) => f.id == 'Width')?.selectedOptions[0],
    Profile: facetFilters.find((f) => f.id == 'Profile')?.selectedOptions[0],
    RimDiameter: facetFilters.find((f) => f.id == 'RimDiameter')
      ?.selectedOptions[0],
    rearWidth: currentQuery.get('rearWidth'),
    rearProfile: currentQuery.get('rearProfile'),
    rearRimDiameter: currentQuery.get('rearRimDiameter'),
  };

  Array.from(links).forEach((anchor) => {
    const newUrl = new URL(anchor.href);

    Object.keys(data).forEach((key) => {
      const value = data[key];
      if (!!value) {
        newUrl.searchParams.set(key, value);
      } else {
        newUrl.searchParams.delete(key);
      }
    });
    anchor.href = newUrl.toString();
  });
};
